<div class="dialog-container">
  <oph-x-button class="cb-salvage-dialog__close-button" (click)="onCancel()" title="Close dialog" />
  <cb-dialog-header
    icon="assets/img/icons/challenge-builder/salvages.png"
    [title]="titleVariable() + ' Salvage'"
    [description]="titleVariable() + ' cycle-saving task.'"
  />

  <div class="dialog-content">
    <div class="form-group">
      <label class="form-label">Task Name</label>
      <input
        type="text"
        class="form-input"
        placeholder="Enter task name"
        [ngModel]="salvageName()"
        (ngModelChange)="salvageName.set($event)"
      />
    </div>

    <div class="form-group">
      <label class="form-label">Target</label>
      <button type="button" class="select-button target-button" [matMenuTriggerFor]="targetMenu">
        <span class="target-button-text">{{ selectedTargetName() }}</span>
        <mat-icon svgIcon="chevron-down"></mat-icon>
      </button>
      <mat-menu #targetMenu="matMenu" class="oph-select-menu">
        @for (target of targets; track target.targetName) {
          <button type="button" (click)="onTargetSelect(target)" class="oph-select-menu-item">
            {{ target.targetName }}
          </button>
        }
      </mat-menu>
    </div>
  </div>

  <cb-dialog-footer [loading]="loading()" [saveDisabled]="saveDisabled()" (cancel)="onCancel()" (save)="onSave()" />
</div>
